import { render, staticRenderFns } from "./serverException.vue?vue&type=template&id=5173c2af&"
import script from "./serverException.vue?vue&type=script&lang=js&"
export * from "./serverException.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports